import React from 'react';
import { validateConnection } from '../../utils/DesignerUtils';
import NodeContent from './NodeContent';
import { Connection, Handle, NodeProps, Position } from 'reactflow';
import { useSelector } from 'react-redux';
import { getUsedItemSelector } from '../../slices/designerSlice';
import { PortInfo } from '../../utils';
import { UsedItem } from '../../models/generics';
import { BdaService } from '../../models/BdaService';
import { BdaDataset } from '../../models/BdaDataset';
import classNames from 'classnames';

export default function AssetNode({ data, type }: NodeProps) {
  const getUsedItem = useSelector(getUsedItemSelector);

  const isValidConnection = (connection: Connection): boolean => {
    const isValid = validateConnection(connection.sourceHandle!, connection.targetHandle!);

    if (type === 'model') return isValid;

    const targetItem = getUsedItem(connection.target) as UsedItem<BdaService>;
    const sourceItem = getUsedItem(connection.source) as UsedItem<BdaDataset>;
    const targetInput = targetItem.inputs!.find((input: PortInfo) => input.id === connection.targetHandle);
    return isValid && (data.placeholder || (targetInput.datasetMode === 'streaming' && sourceItem.datasource!.type === 'messageBroker') || (targetInput.datasetMode !== 'streaming' && sourceItem.datasource!.type !== 'messageBroker'));
  }

  return (
    <div className={classNames(`designer-node ${type}-node`, { placeholder: data.placeholder })}>
      {/* <Handle type="target" position="left" /> */}
      <NodeContent title={data.text} type={type} trailing={data.trailing} vertical />
      <Handle type="source" id={`input-${type}`} className={`custom-handle ${type}-handle`} position={Position.Bottom} isValidConnection={isValidConnection} />
    </div>
  );
}
